import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";

import {
  emptyString,
  screenWidthConstant,
  customerSurveyConstants,
  customerSurveyLabels,
} from "../../../../constants";

/**
 * Centered brand logo banner used on empty / expired / loading survey states.
 */
const SurveyLogoBanner = ({ brandDetail, windowWidth }) => {
  const logoSrc = brandDetail?.logoUrl || brandDetail?.logoURL;

  return (
    <div
      className={`px-4 text-center ${
        windowWidth > screenWidthConstant ? "survey-logo" : emptyString
      } py-3 vw-100`}
    >
      {logoSrc ? (
        <Image
          src={logoSrc}
          fluid
          width={customerSurveyConstants.SURVEY_LOGO_WIDTH_PX}
          alt={customerSurveyLabels.LOGO_ALT}
        />
      ) : (
        emptyString
      )}
    </div>
  );
};

SurveyLogoBanner.propTypes = {
  brandDetail: PropTypes.object,
  windowWidth: PropTypes.number,
};

export default SurveyLogoBanner;
